import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null, // Initially no user
};

export const loginUserSlice = createSlice({
  name: 'loginUser',
  initialState,
  reducers: {
    // Ensure this action has a valid 'type' property
    getUser: (state, action) => {
      state.user = action.payload;
    },
    logoutUser: (state) => {
      state.user = null;
    },
  },
});

// Export actions and reducer
export const { getUser, logoutUser } = loginUserSlice.actions;
export default loginUserSlice.reducer;
